import GLightbox    from '../vendors/lightbox.min';

export default function lightBox () {
    const elem = $('.gallery-item');

    if (elem.length) {
        const myLightbox = new GLightbox({
            selector: 'gallery-item'
        });
    }
}



// WEBPACK FOOTER //
// ./front/bankomania/js/modules/gallery-lightbox.js